import { CheckCircle2 } from "lucide-react";

export const Success = ({ title, text, onAgain, testid }) => (
  <div className="lg-done lg-fade" data-testid={testid}>
    <CheckCircle2 size={44} style={{ margin: "0 auto 12px" }} />
    <h2 style={{ fontSize: 22, marginBottom: 8 }}>{title}</h2>
    <p className="lg-lead" style={{ margin: "0 auto 20px" }}>{text}</p>
    <button className="lg-btn ghost" onClick={onAgain} data-testid={`${testid}-again`}>Send another</button>
  </div>
);
